/**
 * Las cuatro promesas de la tienda, bajo el carrusel.
 *
 * Responden en la primera pantalla lo que un comprador nuevo pregunta antes de
 * confiar: si despachan, cuanto sale, si el stock es real y si dan factura.
 */
import { SITIO } from '../../configuracion/sitio';
import { useDespacho } from '../../contexto/despacho-contexto';
import { ofreceDespacho, ofreceRetiro, soloCoordinar } from '../../utilidades/entrega';
import { pesos } from '../../utilidades/formato';
import { Icono, type NombreIcono } from '../comunes/Icono';

interface Promesa {
  icono: NombreIcono;
  titulo: string;
  detalle: string;
}

export function TiraConfianza() {
  const { opciones } = useDespacho();
  const despachoGratisDesde = opciones?.despachoGratisDesde ?? null;

  // Las dos primeras promesas dependen de lo que el panel deje encendido: no
  // se promete despacho ni retiro que hoy no se ofrece. Con los dos apagados,
  // lo que se promete es que la entrega se acuerda con el comprador.
  const promesasEntrega: Promesa[] = [
    ...(ofreceDespacho(opciones)
      ? [
          {
            icono: 'camion' as const,
            titulo: 'Despacho a todo Chile',
            detalle:
              despachoGratisDesde !== null
                ? `Gratis en compras sobre ${pesos(despachoGratisDesde)}`
                : 'A cualquier region del pais',
          },
        ]
      : []),
    ...(ofreceRetiro(opciones)
      ? [
          {
            icono: 'tienda' as const,
            titulo: 'Retiro en tienda',
            detalle: `${SITIO.direccion.calle}, ${SITIO.direccion.comuna}`,
          },
        ]
      : []),
    ...(soloCoordinar(opciones)
      ? [
          {
            icono: 'camion' as const,
            titulo: 'Entrega a tu medida',
            detalle: 'La coordinamos contigo por teléfono',
          },
        ]
      : []),
  ];

  const promesas: Promesa[] = [
    ...promesasEntrega,
    {
      icono: 'escudo',
      titulo: 'Stock real en línea',
      detalle: 'Lo que ves disponible, está en bodega',
    },
    {
      icono: 'factura',
      titulo: 'Boleta o factura',
      detalle: 'Te llega por correo con tu compra',
    },
  ];

  return (
    <ul className="tira-confianza" aria-label="Cómo compras en Bandu">
      {promesas.map((promesa) => (
        <li className="confianza" key={promesa.titulo}>
          <Icono nombre={promesa.icono} />
          <div>
            <p className="t">{promesa.titulo}</p>
            <p className="d">{promesa.detalle}</p>
          </div>
        </li>
      ))}
    </ul>
  );
}
